'use strict';

/**
 * Component for the locality selection
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var Html = require('base/Colido.Html');
var Awesomplete = require('vendor/awesomplete');

var template = require('../../../templates/components/detail/field-locality.hbs');

var LocalityComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'component-' + _.camelToHyphen(field.type);
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        fullLocality: function() {
            var field = this.getOption('field');
            var locality = this.model.get(field.name);

            return locality ? locality.full : '';
        },
    },

    getText: function() {
        var field = this.getOption('field');

        return this.model.getTextValue(field.name);
    },

    hasValue: function() {
        var field = this.getOption('field');
        var locality = this.model.get(field.name);

        return locality ? true : false;
    },
});

module.exports = LocalityComponent;